import type { TaskPriority } from '../../../store/slices/tasks';
import { useTaskTranslation } from '../hooks/useTaskTranslation';
import styles from './TaskPriorityIndicator.module.css';

export const TaskPriorityIndicator = ({
  priority,
  showLabel = false,
}: {
  priority?: TaskPriority;
  showLabel?: boolean;
}) => {
  const { translations } = useTaskTranslation();
  if (!priority) return null;
  const label = translations(`task_board.priority_${priority}`);
  const description = `${translations('task_board.priority')}: ${label}`;
  return (
    <span className={`${styles.indicator} ${styles[priority]}`} title={description}>
      <svg width="16" height="16" viewBox="0 0 16 16" role="img" aria-label={description}>
        <path
          d={
            priority === 'high'
              ? 'M4 8l4-4 4 4M4 12l4-4 4 4'
              : priority === 'low'
              ? 'M4 6l4 4 4-4'
              : 'M4 6h8M4 10h8'
          }
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      {showLabel && <span>{label}</span>}
    </span>
  );
};
